import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
} from "reactstrap";
import { Link, Redirect } from "react-router-dom";
// react plugin used to create charts
// import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import axios from "axios";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  // Progress,
  // Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard,
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";
import {
  DownloadOutlined,
  UserOutlined,
  CalendarOutlined,
  PlusOutlined,
  TagsOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Button, Radio, Space, Divider, message, Spin, Statistic, Progress } from "antd";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
  ComposedChart,
  LabelList,
  Pie,
  PieChart,
  Sector,
} from "recharts";
import { CardActions } from "material-ui";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);
// var mqtt    = require('mqtt');
// var options = {
//     protocol: 'mqtt',
//     // clientId uniquely identifies client
//     // choose any string you wish
//     clientId: 'b0908853'
// };
// var client  = mqtt.connect('ws://mqtt.nadunet.es:8083', options);

// var client  = mqtt.connect('ws://nadunet.es:8083');
// client.on('connect', function () {
//   client.subscribe('outTopic', function (err) {
//     if (!err) {
//       client.publish('outTopic', '1');
//     }
//   });
// });
// client.on('message', function (topic, message) {
//   // message is Buffer
//   console.log("--------- MQTT ---------");
//   console.log(message.toString());
//   client.end();
// });

var mapData = {
  AU: 760,
  BR: 550,
  CA: 120,
  DE: 1300,
  FR: 540,
  GB: 690,
  GE: 200,
  IN: 200,
  RO: 600,
  RU: 300,
  US: 2920,
};

var dashboardOrdersTitleStyle = {
  margin: "0 0 20px 20px",
  color: "#FFF",
};

var messageCounter = 0;
const toCurrency = (value) =>
  new Intl.NumberFormat("es-ES", {
    useGrouping: true,
  }).format(value);

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};
const renderActiveShape = (props) => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
    suffix,
    name
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";
  const total = toCurrency(value);
  let formattedSuffix = suffix || "";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={-18}
        textAnchor={textAnchor}
        fill="#eee"
      >{`${name}`}</text>
      <br />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#eee"
      >{`${total} ${formattedSuffix}`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#aaa"
      >
        {`(${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};
class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");
    if (this.props.userData.isTechnician()) {
      this.redirectTo("/citas");
    }
    /* ////console.log("########## PROPS ###########");
    ////console.log(props); */
    this.state = {
      servicesSize: "auto",
      customersChartReady: false,
      ordersToDisplayInChart: 6,
      prizeNumber: 0,
      mustSpin: false,
      waitingResult: false,
      kpis: null,
      activeIndex: [],
    };

    this.createMobileCards = this.createMobileCards.bind(this);
    this.addSize = this.addSize.bind(this);
    this.subSize = this.subSize.bind(this);
    this.refreshInternet = this.refreshInternet.bind(this);
    this.loadCustomersChart = this.loadCustomersChart.bind(this);
    this.createActiveClientsCard = this.createActiveClientsCard.bind(this);
    this.createMobileProceduresCard = this.createMobileProceduresCard.bind(
      this
    );
    this.createMobileRejectedProceduresCard = this.createMobileRejectedProceduresCard.bind(
      this
    );
    this.createWebMobileRequestsCard = this.createWebMobileRequestsCard.bind(
      this
    );
    this.updateStatus = this.updateStatus.bind(this);
    this.publishChange = this.publishChange.bind(this);
    this.downloadXml = this.downloadXml.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.getKPIs = this.getKPIs.bind(this);
    this.buildKPIs = this.buildKPIs.bind(this);

    let externalUsers = ["Oniti"];
    if (externalUsers.indexOf(this.props.mainState.user.name) > -1) {
      this.props.history.push("/clientes");
    }
  }
  onPieEnter = (_, index) => {
    let activeIndex = this.state.activeIndex;
    activeIndex[_.parent] = index;
    this.setState({
      activeIndex: activeIndex,
    });
  };
  componentDidMount() {
    this.getKPIs();
    // client.subscribe('naduhome_1/outTopic');
    // client.on('message', this.updateStatus.bind(this));
    // client.on('connect', () => {
    //   // console.log("");
    //   // console.log("----------------------------------------");
    //   // console.log("------------ MQTT Connected ------------");
    //   // console.log("----------------------------------------");
    //   // console.log("");
    //   // client.publish('inTopic', '0');
    // });
  }
  updateStatus(topic, message) {
    // console.log("------------ MQTT: " + topic + " [" + messageCounter++ + "] ------------");
    // let msg = message.toString();
    // // console.log(msg);
    // this.setState({ message: msg });
  }
  publishChange() {
    // let message = "0";
    // let topic = "naduhome_1/inTopic";
    // if (this.state.message === "0") message = "1";
    // // console.log("------------ MQTT OUT: " + topic + " [" + messageCounter++ + "] ------------");
    // // console.log(message);
    // client.publish(topic, message);
  }
  getKPIs() {
    // this.props.createContract(contract);
    if (this.state.gettingKPIs) return;
    this.setState({ gettingKPIs: true });
    this.props.userData
      .getKPIs()
      .then((result) => {
        this.setState({ gettingKPIs: false });
        if (result.ok) {
          this.setState({ kpis: result.kpis });
        } else {
          this.setState({ kpis: result.kpis });
          console.log("Something went wrong getting KPIs: " + result.error);
          message.error(result.error);
        }
      })
      .catch((error) => {
        this.setState({ gettingKPIs: false });
        // Error 😨
        console.log(
          "Error al guardar las facturas de proveedores: " + error.message
        );
        message.error(error.message);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  loadCustomersChart() {
    let customersChartDates = [];
    let customersChartCounts = [];
    let partialOrders = this.props.mainState.customersLastMonths.sort(
      (a, b) =>
        new Date(...a.month.split("-").reverse()) -
        new Date(...b.month.split("-").reverse())
    );

    partialOrders.map((currentCount, key) => {
      customersChartDates.push(
        moment(currentCount.month, "DD-M-YYYY").format(
          "MMM YYYY"
        ) /* 
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        }) 
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")*/
      );
      customersChartCounts.push(currentCount.count);
    });

    let customersChart = {
      data: (canvas) => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");

        return {
          labels: customersChartDates,
          datasets: [
            {
              label: "Clientes",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: customersChartCounts,
            },
          ],
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0,
          },
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest",
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                  // Convert the number to a string and splite the string every 3 charaters from the end
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);

                  // Convert the array to a string and format the output
                  value = value.join(".");
                  return value; // + ' €';
                },
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent",
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)",
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
              },
            },
          ],
        },
      },
    };

    this.setState({
      customersChartReady: true,
      customersChart: customersChart,
    });
  }
  addSize() {
    this.setState({
      servicesSize: this.state.servicesSize + 1,
    });
  }
  subSize() {
    this.setState({
      servicesSize: this.state.servicesSize - 1,
    });
  }
  createTableData() {
    var tableRows = [];
    for (var i = 0; i < table_data.length; i++) {
      tableRows.push(
        <tr key={i}>
          <td>
            <div className="flag">
              <img src={table_data[i].flag} alt="us_flag" />
            </div>
          </td>
          <td>{table_data[i].country}</td>
          <td className="text-right">{table_data[i].count}</td>
          <td className="text-right">{table_data[i].percentage}</td>
        </tr>
      );
    }
    return tableRows;
  }
  createMobileCards() {
    let mobileContent = null;
    /*if(this.props.mainState.customersMobilesLoaded && this.props.mainState.customersMobilesCount > 0){
      mobileContent = 
        <Statistics
          showIcon
          iconState="primary"
          icon="tech_mobile"
          title={this.props.mainState.customersMobilesCount}
          subtitle="Móviles activos"
        />;
    }else if(this.props.mainState.customersMobilesLoaded){
      mobileContent = 
        <Statistics
          showIcon
          iconState="danger"
          icon="tech_mobile"
          title={0}
          subtitle="Ninguna línea móvil activa"
        />;
    }else{
      mobileContent = 
        <Statistics
          showIcon
          iconState="default"
          icon="now-ui-icons arrows-1_refresh-69 spin"
          title="Cargando..."
          subtitle="Móviles"
        />;
    }*/

    mobileContent = (
      <Statistics
        showIcon
        iconState="primary"
        icon="now-ui-icons tech_mobile"
        title="Móviles"
        subtitle="Lista de móviles"
      />
    );

    mobileContent = (
      <Col xs={12} md={this.state.servicesSize}>
        <Card className="card-stats card-raised">
          <CardBody>
            <Row>
              <Col xs={12} md={12}>
                <Link to={"/movil"}>{mobileContent}</Link>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    );

    return mobileContent;
  }
  createMobileProceduresStyle(procedureType) {
    let statistic = null;
    let procedureStateColor = "default";
    let procedureStateIcon = "default";
    let procedureStateText = /*"Trámites " + */ procedureType.estado_tramite;
    // let isCurrentStatus = procedureType.estado_tramite === this.state.procedureStatus;

    switch (procedureType.estado_tramite) {
      case "Pendiente":
        procedureStateColor = "default";
        procedureStateIcon = "travel_info";
        procedureStateText = procedureStateText + "s";
        break;
      case "Procesando":
        procedureStateColor = "warning";
        procedureStateIcon = "loader_refresh spin";
        break;
      case "Error":
        procedureStateColor = "danger";
        procedureStateIcon = "health_ambulance";
        // procedureStateText = "Trámites con " + procedureType.estado_tramite;
        break;
      case "Aceptado":
        procedureStateColor = "info";
        procedureStateIcon = "ui-1_check";
        procedureStateText = procedureStateText + "s";
        break;
      case "Finalizado":
        procedureStateColor = "primary";
        procedureStateIcon = "ui-2_favourite-28";
        procedureStateText = procedureStateText + "s";
        break;
      case "ICC previo incorrecto":
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_settings-90";
        procedureStateText = /*"Trámites "error */ "prev icc";
        break;
      case "Rechazado":
        procedureStateColor = "danger";
        procedureStateIcon = "ui-2_time-alarm";
        procedureStateText = procedureStateText + "s";
        // procedureStateText = procedureStateText + " [" + procedure.motivo_rechazo + "]"
        break;
      case "Cancelado":
        procedureStateColor = "default";
        procedureStateIcon = "media-1_button-power";
        procedureStateText = procedureStateText + "s";
        break;
      default:
    }

    statistic = (
      <Statistics
        showIcon
        iconState={procedureStateColor}
        icon={procedureStateIcon}
        title={procedureType.contador}
        subtitle={procedureStateText}
      />
    );

    return statistic;
  }
  createMobileProceduresCard() {
    let mobileContent = [];
    if (
      this.props.mainState.mobileProceduresCountLoaded &&
      this.props.mainState.mobileProceduresCount.length > 0
    ) {
      this.props.mainState.mobileProceduresCount.map((procedureType, key) => {
        mobileContent.push(
          <Col
            xs={12}
            md={this.state.servicesSize}
            key={procedureType.estado_tramite}
          >
            <Card className="card-stats card-raised">
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Link to={"/tramites"}>
                      {this.createMobileProceduresStyle(procedureType)}
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    } else if (this.props.mainState.mobileProceduresCountLoaded) {
      mobileContent = (
        <Statistics
          showIcon
          iconState="danger"
          icon="education_paper"
          title={0}
          subtitle="Ningún trámite en proceso"
        />
      );
    } else {
      mobileContent.push(
        <Col xs={12} md={this.state.servicesSize} key="cargando-tramites">
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Cargando..."
                    subtitle="Trámites"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }

    return mobileContent;
  }
  createWebMobileRequestsStyle(requestType) {
    let statistic = null;
    let requestStateColor = "default";
    let requestStateIcon = "default";
    let requestStateText = /*"Solicitudes " + */ requestType.estado_solicitud;

    switch (requestType.estado_solicitud) {
      case "Ficha no creada":
        requestStateColor = "danger";
        requestStateIcon = "ui-2_time-alarm";
        break;
      case "Ficha lista":
        requestStateColor = "warning";
        requestStateIcon = "ui-2_settings-90";
        break;
      case "SIM enviada":
        requestStateColor = "info";
        requestStateIcon = "shopping_delivery-fast";
        // procedureStateText = "Trámites con " + requestType.estado_tramite;
        break;
      case "SIM recibida":
        requestStateColor = "primary";
        requestStateIcon = "ui-1_check";
        break;
      default:
    }

    statistic = (
      <Statistics
        showIcon
        iconState={requestStateColor}
        icon={requestStateIcon}
        title={requestType.contador}
        subtitle={requestStateText}
      />
    );

    return statistic;
  }
  createWebMobileRequestsCard() {
    let mobileContent = [];
    if (
      this.props.mainState.webMobileRequestsCountLoaded &&
      this.props.mainState.webMobileRequestsCount.length > 0
    ) {
      this.props.mainState.webMobileRequestsCount.map((requestType, key) => {
        mobileContent.push(
          <Col
            xs={12}
            md={this.state.servicesSize}
            key={requestType.estado_solicitud}
          >
            <Card className="card-stats card-raised">
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Link to={"/web/solicitudes-movil"}>
                      {this.createWebMobileRequestsStyle(requestType)}
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    } else if (this.props.mainState.webMobileRequestsCountLoaded) {
      mobileContent = (
        <Statistics
          showIcon
          iconState="danger"
          icon="education_paper"
          title={0}
          subtitle="Ninguna solicitud"
        />
      );
    } else {
      mobileContent.push(
        <Col xs={12} md={this.state.servicesSize} key="cargando-solicitudes">
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Cargando..."
                    subtitle="Solicitudes"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }

    return mobileContent;
  }
  createMobileRejectedProceduresCard() {
    let mobileContent = null;
    if (
      this.props.mainState.mobileRejectedProceduresCountLoaded &&
      this.props.mainState.mobileRejectedProceduresCount > 0
    ) {
      mobileContent = (
        <Statistics
          showIcon
          iconState="danger"
          icon="ui-1_simple-remove"
          title={this.props.mainState.mobileRejectedProceduresCount}
          subtitle="Trámites rechazados"
        />
      );
    } else if (this.props.mainState.mobileRejectedProceduresCountLoaded) {
      mobileContent = (
        <Statistics
          showIcon
          iconState="primary"
          icon="ui-1_simple-remove"
          title={0}
          subtitle="Ningún trámite rechazado"
        />
      );
    } else {
      mobileContent = (
        <Statistics
          showIcon
          iconState="default"
          icon="now-ui-icons arrows-1_refresh-69 spin"
          title="Cargando..."
          subtitle="Trámites rechazados"
        />
      );
    }

    mobileContent = (
      <Col xs={12} md={this.state.servicesSize}>
        <Card className="card-stats card-raised">
          <CardBody>
            <Row>
              <Col xs={12} md={12}>
                <Link to={"/tramites"}>{mobileContent}</Link>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    );

    return mobileContent;
  }
  createInternetCards() {
    let internetContent = null;
    if (
      this.props.mainState.hasInternet &&
      this.props.mainState.internetLoaded
    ) {
      internetContent = (
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="primary"
                    icon="location_world"
                    title="Internet"
                    subtitle={this.props.mainState.internet_plan.name}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    } else if (this.props.mainState.internetLoaded) {
      internetContent = (
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="location_world"
                    title="Internet"
                    subtitle="Sin conexión en casa..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    } else {
      internetContent = (
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Internet"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }
    return internetContent;
  }
  createActiveClientsCard() {
    let activeClientsContent = null;
    /*if(this.props.mainState.customersCountLoaded && this.props.mainState.customersCount > 0){      
      activeClientsContent = 
        <Statistics
          showIcon
          iconState="info"
          icon="users_single-02"
          title={this.props.mainState.customersCount}
          subtitle="Clientes"
        />;
    }else if(this.props.mainState.customersCountLoaded){
      activeClientsContent = 
        <Statistics
          showIcon
          iconState="danger"
          icon="users_single-02"
          title={0}
          subtitle="Sin clientes activos"
        />;
    }else{
      activeClientsContent = 
        <Statistics
          showIcon
          iconState="default"
          icon="now-ui-icons arrows-1_refresh-69 spin"
          title="Cargando..."
          subtitle="Clientes"
        />;
    }*/

    activeClientsContent = (
      <Statistics
        showIcon
        iconState="info"
        icon="users_single-02"
        title="Clientes"
        subtitle="Lista de clientes"
      />
    );

    activeClientsContent = (
      <Col xs={12} md={this.state.servicesSize}>
        <Card className="card-stats card-raised">
          <CardBody>
            <Row>
              <Col xs={12} md={12}>
                <Link to={"/clientes"}>{activeClientsContent}</Link>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    );

    return activeClientsContent;
  }
  refreshInternet() {
    /* ////console.log("################ REFRESH INTERNET ###############"); */
    this.props.loadInternet();
  }
  downloadXml(url, orderNumber, event) {
    // this.setState({
    //   [orderNumber]: true
    // });
    url =
      "https://oficina.nadunet.es/api/rest/nadunet_billing_resources/test_billing";
    axios({
      url: url,
      method: "POST",
      responseType: "blob", // important
      data: { params: {} },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "remesa_test".concat(".xml"));
      document.body.appendChild(link);
      link.click();
      // this.setState({
      //   [orderNumber]: false
      // });
    });
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  getKPIChart(kpi) {
    let content = [];
    switch (kpi.chartType) {
      case "bar":
        content = kpi.axis.x.map((axis) => {
          return (
            <Bar
              key={kpi.name + "-" + axis.dataKey}
              {...axis}
              unit={axis.unit ? axis.unit : ""}
            >
              <LabelList
                style={{ fill: "white" }}
                dataKey={("ratio_" + axis.dataKey).toLowerCase()}
                position="inside"
              />
            </Bar>
          );
        });
        return (
          <ComposedChart
            key={"chart-" + kpi.name}
            width={700}
            height={300}
            data={kpi.values}
            syncId={kpi.syncId}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            {kpi.dataType === "number" ? (
              <Tooltip
                formatter={(value) =>
                  new Intl.NumberFormat("es-ES", {
                    useGrouping: true,
                  }).format(value)
                }
              />
            ) : (
              <Tooltip />
            )}
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" type="category" />
            <YAxis />
            <Legend />
            {content}
          </ComposedChart>
        );
      case "piechart":
        return (
          <PieChart width={400} height={300}>
            <Pie
              data={kpi.values}
              activeIndex={this.state.activeIndex[kpi.name] || 0}
              activeShape={renderActiveShape}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={85}
              fill="#8884d8"
              dataKey="value"
              onMouseEnter={this.onPieEnter}
              // label={renderCustomizedLabel}
              labelLine={false}
              suffix={kpi.suffix}
            >
              <Tooltip />
              {kpi.values.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Pie>
          </PieChart>
        );
      case "line":
        content = kpi.axis.x.map((axis) => {
          return (
            <Line
              key={kpi.name + "-" + axis.dataKey}
              {...axis}
              type="monotone"
              // unit={axis.unit ? axis.unit : ""}
            >
              {/* <LabelList
                style={{ fill: "white" }}
                dataKey={("label_" + axis.dataKey).toLowerCase()}
                position="top"
              /> */}
            </Line>
          );
        });
        return (
          <ComposedChart
            key={"chart-" + kpi.name}
            width={700}
            height={300}
            data={kpi.values}
            // syncId={kpi.syncId}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5
            }}
          >
            {/* {kpi.dataType === "number" ? (
              <Tooltip
                formatter={(value) =>
                  new Intl.NumberFormat("es-ES", {
                    useGrouping: true,
                  }).format(value)
                }
              />
            ) : ( */}
              <Tooltip />
            {/* )} */}
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Legend />
            {content}
          </ComposedChart>
        );
        break;
      default:
        return "Tipo de gráfico no controlado: " + kpi.chartType;
        break;
    }
  }
  getKPIStatistic(kpi) {
    let suffix = <span>{kpi.suffix}</span>;
    let prefix = <span>{kpi.prefix}</span>;
    return (
      <div className="text-center">
        <Statistic
          title={<span style={{ color: kpi.color, display: "block", height: "8px" }}>{kpi.title}</span>}
          value={kpi.value}
          precision={kpi.precision || 0}
          valueStyle={{ fontSize: "40px" }}
          prefix={prefix}
          suffix={suffix}
        />
      </div>
    );
  }
  getKPIProgress(kpi) {
    switch (kpi.progressType) {
      case "bar":
        return <Progress percent={kpi.percent} type="line" />;
        break;
      case "dashboard":
        return (
          <Progress
            type="dashboard"
            strokeColor={kpi.strokeColor}
            percent={kpi.percent}
            format={() => {
              if (kpi.percent < 100) {
                return <span>{kpi.value}/{kpi.max}</span>
              } else {
                return null;
              }
            }}
          />
        );
        break;
      default:
        break;
    }
  }
  buildKPIs() {
    const { gettingKPIs, kpis } = this.state;
    if (gettingKPIs) {
      return (
        <div>
          <Spin indicator={antIcon} />
          <span style={{ marginLeft: 8 }}>Cargando KPIs...</span>
        </div>
      );
    } else {
      if (!kpis) return "No hay KPIs";
      return kpis.map((kpiDepartment) => {
        return (
          <Row key={"kpi-" + kpiDepartment.name}>
            <Col xs={12}>
              <CardTitle>{kpiDepartment.name}</CardTitle>
            </Col>
            {kpiDepartment.kpis.map((kpi) => {
              let content = null;
              switch (kpi.type) {
                case "chart":
                  content = this.getKPIChart(kpi);
                  break;
                case "statistics":
                  content = this.getKPIStatistic(kpi);
                  break;
                case "progress":
                  content = this.getKPIProgress(kpi);
                  break;
                case "text":
                  content = <span>{kpi.content}</span>;
                  break;
                default:
                  content = "Tipo no controlado: " + kpi.type;
                  break;
              }
              let size = kpi.size || { xs: 12, md: 4 };
              if (kpi.type === "separator") {
                return (
                  <Col xs={12}>
                    <CardTitle>{kpi.name}</CardTitle>
                  </Col>
                );
              }
              return (
                <Col
                  key={"kpi-" + kpiDepartment.name + "-" + kpi.name}
                  {...size}
                >
                  <Card className={kpi.card_class}>
                    {/* <CardHeader className="text-left">
                      <CardTitle>{kpi.name}</CardTitle>
                    </CardHeader> */}
                    <CardBody>
                      <CardTitle>{kpi.name}</CardTitle>
                      {content}
                    </CardBody>
                    <CardFooter>{kpi.bottom_line}</CardFooter>
                  </Card>
                </Col>
              );
            })}
          </Row>
        );
      });
    }
  }
  render() {
    // console.log(" ESTADO ACTUAL ");
    // console.log(this.state);
    // let mqttButton =
    //   <Button icon onClick={this.publishChange} color={this.state.message === "1"? "primary" : "danger"}>
    //     <i className="now-ui-icons business_bulb-63" />
    //   </Button>;
    if (
      this.props.mainState.customersLastMonthsLoaded &&
      !this.state.customersChartReady
    )
      this.loadCustomersChart();
    return (
      <div>
        <PanelHeader
          size="sm"
          // content={
          //   <div>
          //     <h6 style={dashboardOrdersTitleStyle}>Evolución clientes</h6>
          //   <Line
          //     data={!this.state.customersChartReady? dashboardPanelChart.data : this.state.customersChart.data}
          //     options={!this.state.customersChartReady? dashboardPanelChart.options : this.state.customersChart.options}
          //   />
          //   </div>
          // }
        />
        <div className="content">
          <Row>
            {/* <Button
              color="danger"
              size="sm"
              onClick={e =>
                this.downloadXml(null, null, e)
              }
            >
              Test remesa XML
            </Button> */}
            {/* {mqttButton} */}
            <Card>
              <CardHeader>
                <CardTitle>
                  <span>
                    ¡Te damos la bienvenida al nuevo{" "}
                    <span
                      style={{
                        padding: "10px 20px",
                        borderRadius: "5px",
                        background: "rgb(203 203 203)",
                        color: "rgb(35 35 35)",
                      }}
                    >
                      <b>
                        <i class="now-ui-icons business_chart-bar-32"></i>{" "}
                        Dashboard
                      </b>
                    </span>
                    !
                  </span>
                </CardTitle>
              </CardHeader>
              <CardBody>
                <span>
                  Aquí encontrarás información relacionada con tu departamento.
                </span>
              </CardBody>
            </Card>
          </Row>
          <Row>
            <Col xs={12}>
              <Card className="card-plain">
                <CardBody>
                  <Space wrap>
                    <span className="h4">Atajos</span>
                    <Button
                      type="default"
                      icon={<UserOutlined />}
                      size="large"
                      onClick={() => this.redirectTo("/clientes")}
                    >
                      Clientes
                    </Button>
                    <Button
                      type="default"
                      icon={<CalendarOutlined />}
                      size="large"
                      onClick={() => this.redirectTo("/calendario")}
                    >
                      Calendario
                    </Button>
                    <Button
                      type="default"
                      icon={<TagsOutlined />}
                      size="large"
                      onClick={() => this.redirectTo("/tickets")}
                    >
                      Tickets
                    </Button>
                    <Button
                      type="default"
                      icon={<PlusOutlined />}
                      size="large"
                      onClick={() => this.redirectTo("/contratos/nuevo")}
                    >
                      Nuevo contrato
                    </Button>
                  </Space>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader>
                  <CardTitle>Tus KPIs</CardTitle>
                </CardHeader>
              </Card>
            </Col>
          </Row>
          {this.buildKPIs()}
          {/* <Row>
            {this.createActiveClientsCard()}
            {this.createMobileCards()}
          </Row> */}
          {/* <Row>
            <Card className="card-plain">
              <CardHeader className="txt-black">
                <h5>
                  <i className="now-ui-icons education_paper" /> Trámites{"  "}
                </h5>
              </CardHeader>
              <CardBody>
                <Row>
                  {this.createMobileProceduresCard()}
                </Row>
              </CardBody>
            </Card>
          </Row> */}
          {/* <Row>
            <Card className="card-plain">
              <CardHeader className="txt-black">
                <h5>
                  <i className="now-ui-icons education_paper" /> Solicitudes{"  "}
                </h5>
              </CardHeader>
              <CardBody>
                <Row>
                  {this.createWebMobileRequestsCard()}
                </Row>
              </CardBody>
            </Card>
          </Row> */}
          {/* <Row>
            <Card> 
              <CardBody>
                <Button
                  color="info"
                  size="primary"
                  onClick={e =>
                    this.addSize()
                  }
                >
                  <div>
                    <i className="now-ui-icons ui-1_simple-add" />
                  </div>
                </Button>{"  "}
                <Button
                  color="danger"
                  size="sm"
                  onClick={e =>
                    this.subSize()
                  }
                >
                  <div>
                    <i className="now-ui-icons ui-1_simple-delete" />
                  </div>
                </Button>{"  "}
                <Button
                  color="info"
                  size="sm"
                  onClick={e =>
                    this.refreshInternet()
                  }
                >
                  <div>
                    <i className="now-ui-icons arrows-1_refresh-69" />
                  </div>
                </Button>
              </CardBody>
            </Card> 
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Card className="card-stats card-raised">
                <CardBody>
                  <Row>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="primary"
                        icon="ui-2_chat-round"
                        title="859"
                        subtitle="Messages"
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="success"
                        icon="business_money-coins"
                        title={
                          <span>
                            <small>$</small>3,521
                          </span>
                        }
                        subtitle="Today Revenue"
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="info"
                        icon="users_single-02"
                        title="562"
                        subtitle="Customers"
                      />
                    </Col>
                    <Col xs={12} md={3}>
                      <Statistics
                        iconState="danger"
                        icon="objects_support-17"
                        title="353"
                        subtitle="Support Requests"
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Active Users</CardCategory>
                  <CardTitle tag="h2">34,252</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={dashboardActiveUsersChart.data}
                      options={dashboardActiveUsersChart.options}
                    />
                  </div>
                  <Table responsive>
                    <tbody>{this.createTableData()}</tbody>
                  </Table>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Just Updated"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Summer Email Campaign</CardCategory>
                  <CardTitle tag="h2">55,300</CardTitle>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      className="btn-round btn-simple btn-icon"
                      color="default"
                    >
                      <i className="now-ui-icons loader_gear" />
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another Action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                      <DropdownItem className="text-danger">
                        Remove data
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={dashboardSummerChart.data}
                      options={dashboardSummerChart.options}
                    />
                  </div>
                  <div className="card-progress">
                    <Progress badge="Delivery Rate" value="90" />
                    <Progress color="success" badge="Open Rate" value="60" />
                    <Progress color="info" badge="Click Rate" value="12" />
                    <Progress color="primary" badge="Hard Bounce" value="5" />
                    <Progress color="danger" badge="Spam Report" value="0.11" />
                  </div>
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[
                      {
                        i: "now-ui-icons arrows-1_refresh-69",
                        t: "Just Updated"
                      }
                    ]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart">
                <CardHeader>
                  <CardCategory>Active Countries</CardCategory>
                  <CardTitle tag="h2">105</CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={dashboardActiveCountriesCard.data}
                      options={dashboardActiveCountriesCard.options}
                    />
                  </div>
                  <VectorMap
                    map={"world_mill"}
                    backgroundColor="transparent"
                    zoomOnScroll={false}
                    containerStyle={{
                      width: "100%",
                      height: "280px"
                    }}
                    containerClassName="map"
                    regionStyle={{
                      initial: {
                        fill: "#e4e4e4",
                        "fill-opacity": 0.9,
                        stroke: "none",
                        "stroke-width": 0,
                        "stroke-opacity": 0
                      }
                    }}
                    series={{
                      regions: [
                        {
                          values: mapData,
                          scale: ["#AAAAAA", "#444444"],
                          normalizeFunction: "polynomial"
                        }
                      ]
                    }}
                  />
                </CardBody>
                <CardFooter>
                  <Stats>
                    {[{ i: "now-ui-icons ui-2_time-alarm", t: "Last 7 days" }]}
                  </Stats>
                </CardFooter>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Best Selling Products</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table responsive className="table-shopping">
                    <thead>
                      <tr>
                        <th className="text-center" />
                        <th>PRODUCT</th>
                        <th>COLOR</th>
                        <th>Size</th>
                        <th className="text-right">PRICE</th>
                        <th className="text-right">QTY</th>
                        <th className="text-right">AMOUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="img-container">
                            <img src={jacket} alt="..." />
                          </div>
                        </td>
                        <td className="td-name">
                          <a href="#jacket">Suede Biker Jacket</a>
                          <br />
                          <small>by Saint Laurent</small>
                        </td>
                        <td>Black</td>
                        <td>M</td>
                        <td className="td-number">
                          <small>€</small>3,390
                        </td>
                        <td className="td-number">1</td>
                        <td className="td-number">
                          <small>€</small>549
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="img-container">
                            <img src={shirt} alt="..." />
                          </div>
                        </td>
                        <td className="td-name">
                          <a href="#shirt">Jersey T-Shirt</a>
                          <br />
                          <small>by Balmain</small>
                        </td>
                        <td>Black</td>
                        <td>M</td>
                        <td className="td-number">
                          <small>€</small>499
                        </td>
                        <td className="td-number">2</td>
                        <td className="td-number">
                          <small>€</small>998
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="img-container">
                            <img src={swim} alt="..." />
                          </div>
                        </td>
                        <td className="td-name">
                          <a href="#pants">Slim-Fit Swim Short </a>
                          <br />
                          <small>by Prada</small>
                        </td>
                        <td>Red</td>
                        <td>M</td>
                        <td className="td-number">
                          <small>€</small>200
                        </td>
                        <td className="td-number">3</td>
                        <td className="td-number">
                          <small>€</small>799
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5" />
                        <td className="td-total">Total</td>
                        <td className="td-price">
                          <small>€</small>2,346
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row> */}
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx